import { createFileRoute, redirect } from "@tanstack/react-router";

// Partner login lives on the thatKorner platform; send visitors straight there.
export const Route = createFileRoute("/login")({
  beforeLoad: () => {
    throw redirect({ href: "https://www.thatkorner.online/login", statusCode: 302 });
  },
});
